import { z } from "zod";

export const unset = (value: unknown) => (value === "" ? undefined : value);

export const flag = (value: unknown) => (value === "true" ? true : value === "false" ? false : unset(value));

export const blankAsNull = (value: unknown) => (typeof value === "string" && value.trim() === "" ? null : value);

export const absentOrBlankAsNull = (value: unknown) => (value === undefined ? null : blankAsNull(value));

export const searchTextUpTo = (maxLength: number) =>
  z
    .string()
    .trim()
    .max(maxLength)
    .refine((value) => !value.includes("\0"), "no NUL characters");
